export default "__VITE_ASSET__DIZEdU7w__"